export const activeType = {
  1: "按时间自动抽奖",
  // 2: "按人数自动抽奖",
  3: "即开即中",
};

export const activeTypeList = [
  {
    type: 1,
    name: "按时间自动抽奖",
  },
  // {
  //   type: 2,
  //   name: "按人数自动抽奖",
  // },
  {
    type: 3,
    name: "即开即中",
  },
];

export const toModule = {
  1: "每周活动",
  2: "首页",
  3: "拼手速",
};

export const toModuleList = [
  {
    type: 1,
    name: "每周活动",
  },
  {
    type: 2,
    name: "首页",
  },
  {
    type: 3,
    name: "拼手速",
  },
];
